export default function FeaturedRoast() {
  return (
    <section className="w-full bg-background-50 py-24 md:py-32 px-6 md:px-10 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-baseline justify-between gap-4 mb-14 reveal">
          <div>
            <span className="text-xs tracking-[0.35em] uppercase text-accent-700">This Week&apos;s Roast</span>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-primary-950 mt-3">
              Ethiopia, <em>Yirgacheffe Konga</em>
            </h2>
          </div>
          <a
            href="#coffee"
            className="text-sm text-foreground-700 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2 border-b border-foreground-400 pb-1"
          >
            <span>View all coffees</span>
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-14 items-stretch reveal">
          <div className="lg:col-span-3 relative h-[420px] md:h-[560px] overflow-hidden rounded-lg">
            <img
              src={`${import.meta.env.BASE_URL}localized/featured-roast-yirgacheffe-01.jpg`}
              alt="Ethiopia Yirgacheffe Konga featured roast"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute top-6 left-6 bg-background-50 text-primary-900 text-[11px] tracking-[0.3em] uppercase px-4 py-2 rounded-full">
              Freshly Roasted · July 14
            </div>
          </div>

          <div className="lg:col-span-2 flex flex-col justify-between">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <span className="text-xs tracking-widest uppercase text-foreground-500">Origin</span>
                <span className="h-px flex-1 bg-background-200"></span>
                <span className="text-sm text-primary-900 font-medium">Ethiopia</span>
              </div>
              <div className="flex items-center gap-3 mb-6">
                <span className="text-xs tracking-widest uppercase text-foreground-500">Process</span>
                <span className="h-px flex-1 bg-background-200"></span>
                <span className="text-sm text-primary-900 font-medium">Washed</span>
              </div>
              <div className="flex items-center gap-3 mb-6">
                <span className="text-xs tracking-widest uppercase text-foreground-500">Altitude</span>
                <span className="h-px flex-1 bg-background-200"></span>
                <span className="text-sm text-primary-900 font-medium">1,950 – 2,100m</span>
              </div>
              <div className="flex items-center gap-3 mb-8">
                <span className="text-xs tracking-widest uppercase text-foreground-500">Roast</span>
                <span className="h-px flex-1 bg-background-200"></span>
                <span className="text-sm text-primary-900 font-medium">Light</span>
              </div>

              <p className="font-heading italic text-2xl md:text-3xl text-primary-900 leading-snug mb-6">
                &ldquo;Jasmine, bergamot, and a whisper of stone fruit — the cup opens like a garden after rain.&rdquo;
              </p>
              <p className="text-foreground-700 leading-relaxed">
                Grown by 214 smallholder farmers on the slopes of the Gedeb region and washed at the Konga station.
                We roast it lightly to preserve the tea-like clarity that made this micro-lot our pick of the season.
              </p>
            </div>

            <div className="mt-10 flex items-center justify-between border-t border-background-200 pt-6">
              <div>
                <span className="block text-xs uppercase tracking-widest text-foreground-500">12 oz bag</span>
                <span className="block font-heading text-3xl text-primary-950 mt-1">$24</span>
              </div>
              <a
                href="#coffee"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-900 text-background-50 text-sm font-medium hover:bg-primary-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>Add to bag</span>
                <i className="ri-shopping-bag-3-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}